import { Link } from "react-router";
import { ConversionHistoryList } from "@/features/purchasePoints/components/ConversionHistory/ConversionHistoryList";
import { PurchasePointsAccessState } from "@/features/purchasePoints/components/PurchasePointsAccessState";
import { PurchasePointsBalancePanel } from "@/features/purchasePoints/components/PurchasePointsBalancePanel";
import { PurchasePointsLegalNotice } from "@/features/purchasePoints/components/PurchasePointsLegalNotice";
import { RewardHistoryList } from "@/features/purchasePoints/components/RewardHistory/RewardHistoryList";
import {
  PURCHASE_POINTS_BRANDS_LINK_LABEL,
  PURCHASE_POINTS_BRANDS_PATH,
  PURCHASE_POINTS_INTRODUCTION,
  PURCHASE_POINTS_PAGE_LAYOUT,
  PURCHASE_POINTS_TITLE,
} from "@/features/purchasePoints/config/purchasePoints.config";
import { usePurchasePointsBalance } from "@/features/purchasePoints/hooks/usePurchasePointsBalance";
import { usePurchasePointsBlockingAccess } from "@/features/purchasePoints/hooks/usePurchasePointsBlockingAccess";
import { buildYeatiesBreadcrumb } from "@/features/purchasePoints/utils/purchasePointsBreadcrumbs";
import { Breadcrumb } from "@/shared/components/breadcrumb";
import { H1 } from "@/shared/ui/typographies/h1";
import { P } from "@/shared/ui/typographies/paragraph";

const BRANDS_LINK = "text-primary inline-flex w-fit items-center gap-1 text-sm font-semibold hover:underline";

export const PurchasePointsCatalog = () => {
  const { error } = usePurchasePointsBalance();
  const blockingAccess = usePurchasePointsBlockingAccess(error);

  if (blockingAccess) {
    return (
      <div className={PURCHASE_POINTS_PAGE_LAYOUT}>
        <Breadcrumb items={buildYeatiesBreadcrumb()} />
        <H1 data-testid="purchase-points-title">{PURCHASE_POINTS_TITLE}</H1>
        <PurchasePointsAccessState code={blockingAccess.code} detail={blockingAccess.detail} />
      </div>
    );
  }

  return (
    <div className={PURCHASE_POINTS_PAGE_LAYOUT}>
      <Breadcrumb items={buildYeatiesBreadcrumb()} />
      <header className="flex flex-col gap-3">
        <H1 data-testid="purchase-points-title">{PURCHASE_POINTS_TITLE}</H1>
        <P data-testid="purchase-points-introduction">{PURCHASE_POINTS_INTRODUCTION}</P>
        <PurchasePointsLegalNotice />
      </header>

      <PurchasePointsBalancePanel />

      <Link to={PURCHASE_POINTS_BRANDS_PATH} className={BRANDS_LINK} data-testid="purchase-points-brands-link">
        {PURCHASE_POINTS_BRANDS_LINK_LABEL}
      </Link>

      <hr aria-hidden="true" className="border-gray-200 dark:border-gray-700" />

      <RewardHistoryList />
      <ConversionHistoryList />
    </div>
  );
};

PurchasePointsCatalog.displayName = "PurchasePointsCatalog";
